import axios from 'axios'
import store from '@/store'
import router from '@/router'

export default {
  async execute (method, resource, data) {
    // inject the accessToken for each request
    let accessToken = await store.getters.token
    return axios({
      method,
      json: true,
      url: resource,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(req => {
      return req.data
    }).catch(error => {
      const { response } = error
      const { request, ...errorObject } = response // take everything but 'request'
      if (errorObject.status === 401) {
        store.dispatch('LogOut')
        router.push('/Projekte')
      }
    })
  },
  config (id) {
    return this.execute('get', '/api/basic/config/' + id)
  },
  // return the faq entries
  faq () {
    return this.execute('get', '/api/basic/faq')
  },
  // return the current agb
  async agb () {
    return this.execute('get', '/api/basic/agb')
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/api/basic.js